export default "__VITE_ASSET__BUtDysIS__"